
import MenuUploadInfoDialog from "../dialogs/menu-upload-info-dialog.vue";
import MenuCategoryOptionTile from "./menu-category-option-tile.vue";
export default {
  components: { MenuUploadInfoDialog, MenuCategoryOptionTile },
  props: {
    label: "",
    subLabel: "",
    type: "",
    labelClass: "",
    subLabelClass: "",
    itemProp: {},
    parentItemProp: {},
    hasOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      optionList: [
        { label: "Add New Category", id: "add-new-category" },
        { label: "Modify Category", id: "modify-category" },
        { label: "Remove Category", id: "remove-category" }
      ],
      showUnableToDeleteCategoryDialog: false
    };
  },
  methods: {
    handleDeleteCategory(itemProp, parentItemProp) {
      if (itemProp.items.length > 0) {
        this.showUnableToDeleteCategoryDialog = true;
        return;
      } else {
        this.$emit("delete", itemProp, parentItemProp);
      }
    }
  }
};
